'use strict';
angular.module('theme').component('acceptCookies', {
	templateUrl: 'component/accept-cookies.html',
	controller: function($rootScope, $document, $cookies) {
		var body = angular.element($document[0].body);
		var self = this;

		this.accepted = $cookies.get('accept-cookies') || false;

		if (!this.accepted) {
			$rootScope.acceptCookies = false;

			body.addClass('active-cookie-bar');
		}

		this.accept = function() {
			$rootScope.acceptCookies = true;
			self.accepted = true;
			$cookies.put('accept-cookies', true, {
				path: '/',
				expires: moment().add(1, 'year').toDate()
			});

			body.removeClass('active-cookie-bar');
		};
	}
});
